<template>
  <div style="max-width: 600px" class="q-mx-auto q-mt-md">
    <div class="text-right q-mb-sm">
      <q-btn
        label="Save"
        color="primary"
        :loading="saving"
        @click="handleSubmit"
      />
    </div>
    <q-card flat bordered>
      <q-card-section>
        <app-editable-input
          :loadingData="loading"
          :data="name"
          name="name"
          @input="
            name = $event.model;
            delayTouch($v.name, $options.touchMap);
          "
          text="Status Name *"
          :disabled="isParentStatus"
          :error="$v.name.$error"
        />
        <app-select-input
          :loadingData="loading"
          clearable
          use-input
          v-model="parentStatus"
          :options="parentStatusOptions"
          option-label="name"
          option-value="id"
          input-debounce="0"
          @filter="filterParentStatusFn"
          text="Parent Status"
        />
        <app-select-input
          :loadingData="loading"
          clearable
          use-input
          v-model="emailTemplate"
          :options="emailTemplateOptions"
          option-label="name"
          option-value="id"
          input-debounce="0"
          @filter="filterEmailFn"
          text="Email Template"
          hint="If you would like to send an email
          when changing to this status, choose email template above."
        />
        <app-select-input
          :loadingData="loading"
          clearable
          use-input
          v-model="fullpayEmailTemplate"
          :options="emailTemplateOptions"
          option-label="name"
          option-value="id"
          input-debounce="0"
          @filter="filterEmailFn"
          text="Full Pay Email Template"
          hint="If you would like to send an email
          when changing to this status, choose email template above."
        />

        <app-select-input
          :loadingData="loading"
          clearable
          use-input
          v-model="smsTemplate"
          :options="smsTemplateOptions"
          option-label="name"
          option-value="id"
          input-debounce="0"
          @filter="filterSMSFn"
          text="SMS Template"
          hint="If you would like to send an text message when
          changing to this status, choose text messaging template above."
        />
        <app-select-input
          :loadingData="loading"
          clearable
          use-input
          v-model="fullpaySmsTemplate"
          :options="smsTemplateOptions"
          option-label="name"
          option-value="id"
          input-debounce="0"
          @filter="filterSMSFn"
          text="Full Pay SMS Template"
          hint="If you would like to send an text message when
          changing to this status, choose text messaging template above."
        />

        <app-select-input
          :loadingData="loading"
          clearable
          use-input
          v-model="vmAudioFile"
          :options="vmAudioFilesOptions"
          option-label="name"
          option-value="name"
          input-debounce="0"
          @filter="filterVMAudioFilesFn"
          text="VM Audio File"
          hint="If you would like to send an voice mail when
          changing to this status, choose voice mail audio file above."
        />
        <app-select-input
          :loadingData="loading"
          clearable
          use-input
          v-model="fullpayVmAudioFile"
          :options="vmAudioFilesOptions"
          option-label="name"
          option-value="name"
          input-debounce="0"
          @filter="filterVMAudioFilesFn"
          text="Full Pay VM Audio File"
          hint="If you would like to send an voice mail when
          changing to this status, choose voice mail audio file above."
        />
      </q-card-section>
    </q-card>
  </div>
</template>
<script>
import { required } from 'vuelidate/lib/validators';
import graphql from '@client/graphql';
import AppEditableInput from '@client/components/form/editable-input';
import AppSelectInput from '@client/components/form/select-input';

export default {
  name: 'AppStatusDetail',
  metaInfo: {
    title: 'AutoBook Pro - Statuses'
  },
  components: {
    AppEditableInput,
    AppSelectInput
  },
  validations: {
    name: { required }
  },
  apollo: {
    status: {
      query: graphql.queries.getStatus,
      variables() {
        return {
          id: this.$route.params.id
        };
      },
      watchLoading(isLoading) {
        this.loading = isLoading;
      },
      error(error) {
        this.error = error;
      },
      result(result) {
        if (result.loading) return;

        const { status } = result.data;
        this.name = status.name;
        this.parentStatus = status.parent;
        this.emailTemplate = status.emailTemplate;
        this.smsTemplate = status.smsTemplate;
        this.vmAudioFile = { name: status.vmName };
        this.fullpayEmailTemplate = status.fullpayEmailTemplate;
        this.fullpaySmsTemplate = status.fullpaySmsTemplate;
        this.fullpayVmAudioFile = { name: status.fullpayVmName };
        if (!status.parent) {
          this.isParentStatus = true;
        }
      }
    },
    emailTemplates: {
      query: graphql.queries.getEmailTemplates
    },
    smsTemplates: {
      query: graphql.queries.getSMSTemplates
    },
    vmAudioFiles: {
      query: graphql.queries.getVMAudioFiles
    },
    parentStatuses() {
      return {
        query: graphql.queries.getParentStatus,
        variables: { type: this.category }
      };
    }
  },
  data() {
    return {
      loading: false,
      error: null,
      saving: false,
      isParentStatus: false,

      name: null,
      parentStatus: null,
      emailTemplate: null,
      smsTemplate: null,
      vmAudioFile: null,
      fullpayEmailTemplate: null,
      fullpaySmsTemplate: null,
      fullpayVmAudioFile: null,

      parentStatusOptions: [],
      emailTemplateOptions: [],
      smsTemplateOptions: [],
      vmAudioFilesOptions: []
    };
  },
  computed: {
    category() {
      let { category: data } = this.$route.query;
      if (data !== 'QUOTE' && data !== 'ORDER') data = 'QUOTE';
      return data;
    }
  },
  methods: {
    async handleSubmit() {
      this.validate(['name']);

      const payload = {};
      payload.name = this.name;
      if (this.parentStatus) {
        payload.parentId = parseInt(this.parentStatus.id, 10);
      } else {
        payload.parentId = null;
      }
      if (this.emailTemplate) {
        payload.emailTemplateId = parseInt(this.emailTemplate.id, 10);
      } else {
        payload.emailTemplateId = null;
      }
      if (this.fullpayEmailTemplate) {
        payload.fullpayEmailTemplateId = parseInt(this.fullpayEmailTemplate.id, 10);
      } else {
        payload.fullpayEmailTemplateId = null;
      }
      if (this.smsTemplate) {
        payload.smsTemplateId = parseInt(this.smsTemplate.id, 10);
      } else {
        payload.smsTemplateId = null;
      }
      if (this.fullpaySmsTemplate) {
        payload.fullpaySmsTemplateId = parseInt(this.fullpaySmsTemplate.id, 10);
      } else {
        payload.fullpaySmsTemplateId = null;
      }

      if (this.vmAudioFile) {
        payload.vmName = this.vmAudioFile.name;
      } else {
        payload.vmName = null;
      }
      if (this.fullpayVmAudioFile) {
        payload.fullpayVmName = this.fullpayVmAudioFile.name;
      } else {
        payload.fullpayVmName = null;
      }

      this.saving = true;

      try {
        await this.$apollo.mutate({
          mutation: graphql.mutations.updateStatus,
          variables: { id: this.$route.params.id, input: payload }
        });

        this.saving = false;

        this.$router.push({ name: 'statuses' });
      } catch (error) {
        this.saving = false;
        this.notifyNegative(error.message.replace('GraphQL error: ', ''));
      }
    },
    filterParentStatusFn(val, update) {
      update(() => {
        const needle = val.toLowerCase();
        this.parentStatusOptions = this.parentStatuses.filter(
          (v) => v.name.toLowerCase().indexOf(needle) > -1
        );
      });
    },
    filterEmailFn(val, update) {
      update(() => {
        const needle = val.toLowerCase();
        this.emailTemplateOptions = this.emailTemplates.filter(
          (v) => v.name.toLowerCase().indexOf(needle) > -1
        );
      });
    },
    filterSMSFn(val, update) {
      update(() => {
        const needle = val.toLowerCase();
        this.smsTemplateOptions = this.smsTemplates.filter(
          (v) => v.name.toLowerCase().indexOf(needle) > -1
        );
      });
    },
    filterVMAudioFilesFn(val, update) {
      update(() => {
        const needle = val.toLowerCase();
        this.vmAudioFilesOptions = this.vmAudioFiles.filter(
          (v) => v.name.toLowerCase().indexOf(needle) > -1
        );
      });
    }
  }
};
</script>
